import { Typography } from '@one-thd/sui-atomic-components';
import { AuthorizeCard } from '@one-thd/sui-icons';
import React from 'react';
export var PreShipOrderStatus = function (_a) {
    var children = _a.children;
    if (children === undefined) {
        return (React.createElement("div", { className: "sui-flex sui-gap-2 sui-items-center" },
            React.createElement(AuthorizeCard, { size: "small" }),
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Processed")));
    }
    return React.createElement("div", null, children);
};
